import { useState, useEffect } from 'react';
import type { UseServiceBoxReturn } from '../types';

const useServiceBox = (): UseServiceBoxReturn => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const SERVICES_DATA = [
    {
      id: 1,
      title: 'serviceBoxTitle2',
      subtitle: 'serviceBoxSubtitle2',
      image: 'image2',
    },
    {
      id: 2,
      title: 'serviceBoxTitle',
      subtitle: 'serviceBoxSubtitle',
      image: 'image1',
    },
    {
      id: 3,
      title: 'serviceBoxTitle3',
      subtitle: 'serviceBoxSubtitle3',
      image: 'image3',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % SERVICES_DATA.length);
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { SERVICES_DATA, currentIndex, setCurrentIndex };
};

export default useServiceBox;
